import HTTP from '../services/index';
const store = {
    actions:{
        getAllWorkers : async ({}) => {
            try{
                const response = await HTTP.get('/usuarios/byrol/Worker')
                return response
            }catch(error){
                return error.response
            }
        }
    }
}
export default store